import {Dispatcher} from "../../../stem-core/base/Dispatcher";
import type {BaseFlowStep} from "./steps/BaseFlowStep";
import type {FlowMembers} from "./FlowLogic"; // Type-only on purpose: FlowLogic imports this module

// The Flow object will be populated with handlers and state in FlowLogic.js. Both apps import that module
// when they load, before any flow runs, so every member FlowMembers names is there by the time it's read
export const Flow = {} as FlowMembers;


export class FlowPlan extends Dispatcher {
    // Supplied by the constructor; defaults to the active handler's own finalize
    declare finalize: () => any;
    steps: BaseFlowStep[] = [];
    currentStep = 0;

    constructor(steps: (BaseFlowStep | null | false)[] = [], finalize = () => Flow.activeFlowHandler.finalize()) {
        super();

        this.steps = steps.filter(x => x) as BaseFlowStep[]; // Skip null or false steps

        this.finalize = finalize;
    }

    getCurrentStep() {
        return this.steps[this.currentStep];
    }

    isBeforeFirstStep() {
        return this.currentStep === -1;
    }

    goToNextStep() {
        this.currentStep += 1;
    }

    goToPreviousStep() {
        this.currentStep -= 1;
        while (this.currentStep >= 0 && !(this.getCurrentStep().shouldPrompt())) {
            this.currentStep -= 1;
        }
    }

    goToStep(step: BaseFlowStep) {
        for (let index = 0; index < this.steps.length; index++) {
            if (this.steps[index] === step) {
                this.currentStep = index;
                return;
            }
        }
    }

    async prompt(forcePrompt=false) {
        // Skip any invalid steps
        while (this.isBeforeFirstStep() || (this.currentStep < this.steps.length && !forcePrompt && !this.getCurrentStep().shouldPrompt())) {
            this.currentStep += 1;
        }

        if (this.currentStep >= this.steps.length) {
            if (Flow.flowPlan === this) {
                await this.finalize();
                Flow.flowPlan = null; // We're done if the finalization was ok
                Flow.activeFlowHandler = null;
            }
            return;
        }

        await this.getCurrentStep().prompt();

        this.promptNextStep().then(); // TODO @flow2 hmmmm
    }

    async promptNextStep() {
        this.goToNextStep();
        await this.prompt();
    }

    async promptPreviousStep() {
        this.goToPreviousStep();

        if (this.currentStep >= 0) {
            await this.prompt();
        } else {
            // Explicitly marking as outside of the flow
            this.currentStep = -1;
        }
    }
}